export default "__VITE_ASSET__jR$SJXV6__"